export default __webpack_public_path__ + "static/media/Soul.7c5b0182.png";